<template>
    <div class="bcw bcw__disease_ov" >
        <div class="overlay" :class="'bgdark1x--' + currCropObj.logo">
            <img :src="'/crop/pic/white/' + currCropObj.logo">
        </div>
        <div class="disease__inner">
            <header>
                <p class="title">{{ trans('dashboard.dis.title1') }} <span>{{ trans('dashboard.dis.title2') }}</span></p>
                <bcselect :name="'year'" :opt="options" :def="this.currYear" @onselectchange="switchYear"></bcselect>
            </header>
            <main>
                <div v-if="this.switchmode === 0">
                    <tabs :tabs="myTabs" @switchTabControl="switchActiveTab"></tabs>
                </div>
                <div v-if="crops.length === 0" class="zero__dis">
                    <img src="/images/zero_dis2.svg">
                    <p class="title">{{ trans('dashboard.dis.zero.title') }}</p>
                    <p class="subtitle">{{ trans('dashboard.dis.zero.sub') }}</p>
                </div>
                <div v-else id="disease_yield" class="disease__yield">
                    <!--Showing diseases of {{this.currCrop}} in {{this.currYear}}-->
                    <div class="bc__ui__area_chart">
                        <div id="area__chart">
                            <div id="area__tooltip__hook" class="bcw area__tooltip tooltip">
                                <div v-if="diseaseFetched" class="tooltip__content">
                                    <header>
                                        <div>
                                            <p class="title">{{diseaseInTooltip.name}}</p>
                                            <p class="subtitle">{{ trans('dashboard.dis.list') }}</p>
                                        </div>
                                        <div class="segment__content">
                                            <segment-chart :ranks="this.calcRankDistrib()"></segment-chart>
                                        </div>

                                    </header>
                                    <ul>
                                        <li v-for="(parcel, i) in this.diseaseInTooltip.parcels" :key="i">
                                            <div>
                                                <p class="name">{{parcel.name}}</p>
                                                <span>12Aug</span>
                                            </div>
                                            <div class="right"> 
                                                <p>{{ rankToString(parcel.ranks[parcel.ranks.length - 1]) }}</p>
                                                <span :class="'filldis--' + (parcel.ranks[parcel.ranks.length - 1])"></span>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <span class="tooltip-arrow popover-arrow"></span>
                            </div>
                        </div>
                    </div>
                    <div v-if="diseaseFetched" class="featured__disease">
                        <img :src="'/diseasepic/disease/'+featuredDisease.id" />
                        <div v-if="featuredDisease.parcels" class="meta">
                            <p class="subtitle">

                                {{ trans_choice('dashboard.dis.feat.title', featuredDisease.parcels, {crop:currCropObj.id,  year:currYear}) }}

                                <!--
                                {{ trans('dashboard.dis.feat.title1') }}
                                {{ featuredDisease.parcels.length }}
                                {{ trans('dashboard.dis.feat.title2') }}
                                {{currCropObj.id}} {{ trans('dashboard.dis.feat.title3') }}
                                {{currYear}}
                                -->
                            </p>
                            <p class="title">{{featuredDisease.name}}</p>
                            <p class="emp">{{ rankToString(featuredDiseaseTopParcel.ranks[0]) }} {{ trans('dashboard.dis.feat.lvl') }} {{featuredDiseaseTopParcel.name}}</p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<style lang="scss" scoped >

</style>


<script>


import * as d3 from 'd3';


// Note: This is a function because the object is modified
    const EMPTY_CROP = () => ({
        logo: 'general',
        id: '?',
        ix: 0
    });



    export default {

        props: [
            'widget',
        ],

        data(){
            return {
                // 0 for tab
                // 1 for select
                switchmode: 0,
                currCropObj: EMPTY_CROP(),

                currYear: 0,
                myTabs: [],
                options: [],
                diseaseFetched: false,

                // This will come from the endpoint: it has crops->diseases->parcels->ranks
                crops: [],

                featuredDisease: {},
                featuredDiseaseTopParcel: {},
                diseaseInTooltip: {}
            };
        },

        created(){
            this.options = this.widget.options.map(year => +year);
            this.currYear = this.options[0];
        },

        mounted() {
            this.updateWidgetData();
        },

        methods: {

            calcRankDistrib() {
                let tempDis = this.diseaseInTooltip;
                let arrRanks = new Array(5).fill(0);
                let totalRanks = 0;

                tempDis.parcels.forEach((parcel) => {
                    parcel.ranks.forEach((rank) => {
                        arrRanks[rank - 1]++;
                        totalRanks++;
                    })
                });

                const rankDist = arrRanks.map((rank) => {
                    return rank / totalRanks
                })

                return rankDist;
            },

            generateAreaChart(vm) {
                const width = document.querySelector("#disease_yield").clientWidth
                const h = 120;
                const stdRad = 5;
                const hoveredRad = 12;

                let totalX = 0;
                let maxValY = 0;

                totalX = this.crops[this.currCropObj.ix].diseases.length;

                const valAxis = [];

                valAxis.push({'x': 0, 'y': 0})
                
                this.crops[this.currCropObj.ix].diseases.forEach((dis, i) => {
                    valAxis.push({'x': i + 1, 'y': dis.parcels.length})
                })

                valAxis.push({'x': 0, 'y': 0})

                this.crops[this.currCropObj.ix].diseases.forEach((dis) => {
                    if(dis.parcels.length > maxValY) maxValY = dis.parcels.length;
                })

                maxValY = maxValY + 1;

                var log = this.currCropObj.logo;


                var xScale = d3.scaleLinear()
                    .domain([0, totalX + 1]) // input
                    .range([0, width]); // output

                var yScale = d3.scaleLinear()
                    .domain([0, maxValY]) // input 
                    .range([h, 0]); // output 


                var line = d3.line()
                    .x(function(d, i) {
                        return xScale(i); 
                    }) // set the x values for the line generator
                    .y(function(d, i) { 
                        return yScale(d.y); 
                    }) // set the y values for the line generator 
                    .curve(d3.curveMonotoneX) // apply smoothing to the line

                d3.select("#area__chart").select("svg").remove();

                const svg = d3
                    .select("#area__chart")
                    .append("svg")
                    .attr("width", width)
                    .attr("height", h);

                var svgDefs = svg.append('defs');

                var mainGradient = svgDefs.append('linearGradient')
                    .attr('id', 'mainGradient')
                    .attr("gradientTransform", "rotate(90)");

                mainGradient.append('stop')
                    .attr('class', 'stop-top')
                    .attr('offset', '0');

                mainGradient.append('stop')
                    .attr('class', "stop-bottom--"+ this.currCropObj.logo +"")
                    .attr('offset', '1');


                var div = d3.select("#area__tooltip__hook");

                svg.append("path")
                    .datum(valAxis) 
                    .attr("stroke", "#ffffff")
                    .attr("stroke-width", "2px")
                    .attr("class", "filled") 
                    .attr("d", line);
                svg.append("line")
                    .attr("class", "h-line")
                    .style("stroke-dasharray", ("3, 3")) 
                    .style("stroke", "white") 
                    .attr("x1", 0)    
                    .attr("y1", h)     
                    .attr("x2", width)     
                    .attr("y2", h);
                svg.append("line")
                    .attr("class", "v-line")
                    .style("stroke", "white") 
                    .attr("x1", 0)    
                    .attr("y1", h)     
                    .attr("x2", 0)     
                    .attr("y2", 0);

                svg.append("line")
                    .attr("class", "v-line")
                    .style("stroke", "white") 
                    .attr("x1", 0)    
                    .attr("y1", 0)     
                    .attr("x2", -5)     
                    .attr("y2", 5);

                svg.append("line")
                    .attr("class", "v-line")
                    .style("stroke", "white") 
                    .attr("x1", 0)    
                    .attr("y1", 0)     
                    .attr("x2", 5)     
                    .attr("y2", 5);

                var circles = svg.append("g").selectAll(".dot")
                    .data(valAxis)             
                    .enter()
                    .append("g")
                    .append("circle")
                    .attr("r", stdRad)
                    .attr("stroke-width", "2px")
                    .attr("stroke", "#ffffff")
                    .attr("class", function(d,i) {
                        if (i === 0 || i === valAxis.length - 1) {
                            return 'no--display'
                        } else {
                            return "filldark1x--"+log+""
                        }
                    })
                    .attr("cx", function(d,i){
                        return xScale(i);
                    })
                    .attr("cy", function(d){
                        return yScale(d.y);
                    })
                    .attr("fill", "#ffffff")
                    .on("mouseover", function(d, i){
                        highlightDisease(i.x, vm)
                        d3.select(this).transition()
                            .duration(300)
                            .attr("r", hoveredRad);
                        div.transition()		
                            .duration(300)		
                            .style("opacity", 1)
                        div.style("bottom", "calc(100% - "+d3.select(this).attr("cy") + "px" + ")")
                        div.style("left", d3.select(this).attr("cx") + "px")
                        div.style("transform", "translate(-50%, -20px)")	                       
                    })

                    .on("mouseout", function(d){
                        d3.select(this).transition()
                            .duration(300)
                            .attr("r", stdRad);
                        div.transition()		
                            .duration(300)		
                            .style("opacity", 0);
                    });

                svg.append("text")
                    .attr("class", "ax")
                    .attr("dy", ".25em")
                    .attr("text-anchor", "middle")
                    .attr("transform", "translate(12,37) rotate(270)")
                    .text(trans('dashboard.insiders.aff'));

                function highlightDisease(i, vm) {
                    vm.diseaseInTooltip = vm.crops[vm.currCropObj.ix].diseases[i - 1];
                }
            },

            switchActiveTab(i) {
                this.myTabs.forEach((tab) => tab.active = false);
                this.myTabs[i].active = true;
                this.activeTab = i;
                this.currCropObj.logo = this.crops[i].logo_name;
                this.currCropObj.id = trans('common::crop.'+this.crops[i].name+'');
                this.currCropObj.ix = i;
                this.diseaseInTooltip = this.crops[this.currCropObj.ix].diseases[0];
                this.featuredDisease = this.fetchFeaturedDisease();
                this.featuredDiseaseTopParcel = this.fetchFeaturedDiseaseTopParcel();
                let $vm = this;
                this.generateAreaChart($vm);
            },

            switchYear(val) {
                this.currYear = val;
                const option = this.options.indexOf(this.currYear, this.options);
                this.updateWidgetData(option)
            },

            async updateWidgetData(currOption = 0){

                await this.widget.load(currOption);

                this.crops = this.widget.data();

                // Show zero view
                if(!this.crops.length){
                    this.myTabs = [];
                    this.currCropObj = EMPTY_CROP();
                    return;
                }

                (this.crops.length > 3) ? this.switchmode = 1 : this.switchmode = 0;

                this.currCropObj.logo = this.crops[0].logo_name;
                this.currCropObj.id = trans('common::crop.'+this.crops[0].name+'');
                this.currCropObj.ix = 0;

                this.featuredDisease = this.fetchFeaturedDisease();
                this.featuredDiseaseTopParcel = this.fetchFeaturedDiseaseTopParcel();
                this.diseaseInTooltip = this.fetchFeaturedDisease();

                this.myTabs = this.crops.map(crop => {
                    return {
                        name: trans('common::crop.'+crop.name+''),
                        logo: crop.logo_name,
                        active: false
                    }
                });

                this.myTabs[0].active = true;

                this.diseaseFetched = true;

                this.$nextTick(() => {

                    let $vm = this;
                    this.generateAreaChart($vm);

                });


            },

            fetchFeaturedDisease() {
               let currDiseases = this.crops[this.currCropObj.ix].diseases;
               currDiseases = currDiseases.sort((a, b) => b.parcels.length - a.parcels.length);
               return currDiseases[0]
            },

            fetchFeaturedDiseaseTopParcel() {
                let dis = this.featuredDisease;
                dis.parcels.sort((a, b) => b.ranks[0] - a.ranks[0]);
                return dis.parcels[0];
            },
            rankToString(lvl) {
                const lit = [trans('dashboard.insiders.lvls_l.vl'), trans('dashboard.insiders.lvls_l.l'), trans('dashboard.insiders.lvls_l.m'), trans('dashboard.insiders.lvls_l.h'), trans('dashboard.insiders.lvls_l.vh')];
                return lit[lvl - 1];
            }
        }
    }

</script>